import {
  getFlattenedClassrooms,
  getHasSRCContent,
} from "@/assignments/utils/assignmentUtils";

const formatAssignmentMembers = (assignmentMembers) => {
  return assignmentMembers?.map((assignmentMember) => ({
    content: assignmentMember.content,
    content_id: assignmentMember.content.content_id,
  }));
};

// We only want to store the values that will be sent to the POST request in the reducer
export const formatAssignmentForReducer = (assignment, isStudent) => {
  const flatAssignmentClassrooms = getFlattenedClassrooms(
    assignment?.assignment_classrooms,
  );
  const formattedAssignmentMembers = formatAssignmentMembers(
    assignment.assignment_members,
  );
  // We are stripping this key from saved assignments because useAssignmentCreate
  // assumes that any assignment with the copied_from_assignment key is unsaved.
  const shouldIncludeCopiedFromAssignment =
    !assignment.content_id && !!assignment.copied_from_assignment;
  const shouldIncludeActivityElementSelections =
    !!assignment?.activity_element_selections;

  /**
   * Remove user_content_settings_override to trigger advisory modal
   * on initial save of a copied assignment with SRC.
   */
  const hasSRCContent = getHasSRCContent(assignment.assignment_members);
  if (shouldIncludeCopiedFromAssignment && hasSRCContent && !isStudent) {
    assignment.assignment_members?.forEach((assignmentMember) => {
      if (assignmentMember?.content?.user_content_settings_override) {
        delete assignmentMember.content.user_content_settings_override;
      }
    });
  }

  const hasContentSettingsOverride =
    assignment.assignment_members?.[0]?.content?.user_content_settings_override;

  return {
    assignment_id: assignment.assignment_id,
    ...(shouldIncludeActivityElementSelections
      ? {
          activity_element_selections: assignment.activity_element_selections,
        }
      : {}),
    activity_members: assignment.activity_members,
    assignment_classrooms: flatAssignmentClassrooms,
    assignment_groups: assignment.assignment_groups,
    assignment_members: formattedAssignmentMembers,
    assignment_config: assignment.assignment_config,
    content_id: assignment.content_id,
    date_goes_live: assignment.date_goes_live,
    can_edit_assignees: assignment.can_edit_assignees,
    content_settings_override: hasContentSettingsOverride
      ? assignment.assignment_members?.[0]?.content?.content_id
      : undefined,
    date_modified: assignment.date_modified,
    created_by: assignment.created_by,
    ...(shouldIncludeCopiedFromAssignment
      ? { copied_from_assignment: assignment.copied_from_assignment }
      : {}),
    default_reading_level: assignment.default_reading_level,
    date_due: assignment.date_due,
    district_advisory_override: assignment.district_advisory_override,
    hasUnsavedChanges: assignment.hasUnsavedChanges,
    instructions: assignment.instructions,
    is_draft: assignment.is_draft,
    is_reading_level_locked: assignment.is_reading_level_locked,
    title: assignment.title,
    version: assignment.version,
  };
};
